import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { LANGS, translate } from "@/lib/i18n";

const LangContext = createContext(null);
const STORAGE_KEY = "maxine_lang";

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && LANGS[stored]) return stored;
    // Auto-detect once from browser
    const nav = (window.navigator.language || "en").slice(0, 2).toLowerCase();
    return LANGS[nav] ? nav : "en";
  });

  const dir = LANGS[lang]?.dir || "ltr";

  useEffect(() => {
    if (typeof document === "undefined") return;
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.dataset.lang = lang;
  }, [lang, dir]);

  const setLang = (next) => {
    if (!LANGS[next]) return;
    setLangState(next);
    if (typeof window !== "undefined") window.localStorage.setItem(STORAGE_KEY, next);
  };

  const value = useMemo(() => ({
    lang,
    setLang,
    dir,
    t: (key, vars) => translate(lang, key, vars),
  }), [lang, dir]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useI18n must be used inside <LangProvider>");
  return ctx;
}
